import { gql } from '@common/hooks';

export const SubmittalPacketInfoFragment = gql`
  fragment SubmittalPacketFragment on WorksProfile {
    id
    worksSubmittalPackets {
      id
      archived
      files {
        id
        filename
        createdAt
        downloadUrl
      }
    }
  }
`;

type SubmittalPacketFileType = {
  id: string;
  filename: string;
  downloadUrl: string;
  createdAt: string;
};

export type SubmittalPacketInfoType = {
  id: string;
  archived?: boolean;
  files: SubmittalPacketFileType[];
};

export type WorksProfileType = {
  id: string;
  worksSubmittalPackets: SubmittalPacketInfoType[];
};
